import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(c, e) {
  return o(), l("svg", n, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M16.5 5.5c.3-.3.3-.8 0-1.1s-.7-.3-1 0l-5 5-5-5c-.3-.3-.8-.3-1.1 0s-.3.7 0 1l5 5-5 5c-.3.3-.3.8 0 1.1s.8.3 1.1 0l5-5 5 5c.3.3.8.3 1.1 0s.3-.8 0-1.1l-5-5c0 .1 4.9-4.9 4.9-4.9"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
